import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconSalesConfig(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.5 2.5H10.5V4.5H1.5V2.5Z" stroke="currentColor" />
      <path d="M1.5 4.5H4.5V9.5H1.5V4.5Z" stroke="currentColor" />
      <path d="M4.5 4.5H10.5V9.5H4.5V4.5Z" stroke="currentColor" />
    </SVGIcon>
  );
}
